module.exports = __webpack_public_path__ + "img/guides_hi.53a21445.jpg";